import { Dispatch } from 'redux';
import {
  SET_BOOKING_VALUE,
  SET_BOOKING_VALIDITY,
  BOOKING_PRICE_RECEIVE,
  BOOKING_PRICE_FAIL,
  BookingValueAction,
  BookingVadilityAction,
  BookingPriceAction,
  BookingPriceReceiveAction,
  BookingPriceFetchAction,
} from './types';
import ApiClient from '../../../utils/ApiClient';
import I18n from '../../../config/i18n';

export function setBookingValue(name: string, value: number): BookingValueAction {
  return {
    type: SET_BOOKING_VALUE,
    name,
    value,
  };
}

export function setBookingValidity(name: string, isValid: boolean): BookingVadilityAction {
  return {
    type: SET_BOOKING_VALIDITY,
    name,
    isValid,
  };
}

function failBookingPrice(): BookingPriceAction {
  return {
    type: BOOKING_PRICE_FAIL,
  };
}

function receiveBookingPrice(bookingPrice: number): BookingPriceReceiveAction {
  return {
    type: BOOKING_PRICE_RECEIVE,
    bookingPrice,
  };
}

export function fetchBookingPrice(paymentMethod: string): BookingPriceFetchAction {
  return (dispatch: Dispatch) => {
    ApiClient.getBookingPrice(I18n.locale, paymentMethod)
      .then((res: any) => {
        if (Number.isNaN(res.data)) {
          dispatch(failBookingPrice());
        } else {
          dispatch(receiveBookingPrice(Number(res.data)));
        }
      })
      .catch(() => dispatch(failBookingPrice()));
  };
}
